import { removeDiacritics } from './remove-diacritics';

export interface DiacriticsSearchOptions {
  fields?: string[];
}

/**
 * Creates diacritics-insensitive, case-insensitive filter functions for specified fields.
 */

export function createDiacriticsFilters(options: DiacriticsSearchOptions) {
  const { fields } = options;

  const filters: Record<string, any> = {};

  fields?.forEach(field => {

    filters[field] = (filterValue: any, selectedFilterOperation: string) => {
      const getter = (data: any) => {
        return normalizeSearch(data[field]);
      }

      const normalizedValue = normalizeSearch(filterValue);

      return [getter, selectedFilterOperation || 'contains', normalizedValue];
    };
  });

  return filters;
}

export function normalizeSearch(value: any): string {
  return removeDiacritics(value?.toString()).toLowerCase() ?? '';
}
